import httpClient from "@/plugins/axios";

export const getInfoTvScreenWeather = async (screenId) => {
    const response = await httpClient.get(`/admin/v1/infotv/screens/${screenId}/weather/`);
    return response;
}

export const saveInfoTvScreenWeather = async (screenId, weather) => {
    if (weather.id) {
        return updateInfoTvScreenWeather(screenId, weather);
    }
    else {
        return insertInfoTvScreenWeather(screenId, weather);
    }
}

const insertInfoTvScreenWeather = async (screenId, weather) => {
    const response = await httpClient.post(`/admin/v1/infotv/screens/${screenId}/weather/`,
        weather
    );
    return response;
}

const updateInfoTvScreenWeather = async (screenId, weather) => {
    const response = await httpClient.put(`/admin/v1/infotv/screens/${screenId}/weather/${weather.id}/`,
        weather
    );
    return response;
}

export const deleteInfoTvScreenWeather = async (screenId, weatherId) => {
    const response = await httpClient.delete(`/admin/v1/infotv/screens/${screenId}/weather/${weatherId}/`,

    );
    return response;
}

export const getInfoTvScreenSettings = async (screenId) => {
    const response = await httpClient.get(`/admin/v1/infotv/screens/${screenId}/settings/`);
    return response;
}

export const updateInfoTvScreenSettings = async (screenId, settingsData) => {
    const response = await httpClient.patch(`/admin/v1/infotv/screens/${screenId}/settings/`, settingsData);
    return response;
}

export const getInfoTvScreens = async () => {
    const response = await httpClient.get('/admin/v1/infotv/screens/');
    return response;
}

export const getInfoTvScreenContent = async (screenId) => {
    const response = await httpClient.get(`/admin/v1/infotv/screens/${screenId}/content/`);
    return response;
}

export const saveInfoTvScreenContent = async (screenId, content) => {
    const response = await httpClient.post(`/admin/v1/infotv/screens/${screenId}/content/`, content);
    return response;
}

export const deleteInfoTvScreenContent = async (screenId, contentId) => {
    const response = await httpClient.delete(`/admin/v1/infotv/screens/${screenId}/content/${contentId}/`);
    return response;
}

export const sortInfoTvScreenContent = async (screenId, order) => {
    // order should be { primary: [ids], secondary: [ids] }
    const response = await httpClient.post(`/admin/v1/infotv/screens/${screenId}/content/sort/`, order);
    return response;
}

export const uploadAndAddImage = async (screenId, imageData, position) => {
    const formData = new FormData()
    formData.append('title', imageData.title)
    formData.append('image', imageData.imageBlob, imageData.imageName)
    formData.append('position', position)

    const response = await httpClient.post(`/admin/v1/infotv/screens/${screenId}/content/upload/`, formData);
    return response;
}

export const getInfoTvContents = async (params = {}) => {
    const response = await httpClient.get('/admin/v1/infotv/content/', { params });
    return response;
}
export const getInfoTvImage = async (id) => {
    const response = await httpClient.get(`/admin/v1/infotv/content/image/${id}`);
    return response;
}

export const saveInfoTvHtml = async (html) => {

    if (html.id) {
        return await httpClient.put(`/admin/v1/infotv/content/html/${image.id}/`, {
            html
        });
    }
    else {
        return await httpClient.post('/admin/v1/infotv/content/html/', {
            html
        });
    }
}

export const saveInfoTvImage = async (image, newImageBlob, newImageName) => {
    const formData = new FormData()
    formData.append('title', image.title)
    if (newImageBlob) {
        formData.append('image', newImageBlob, newImageName);
    }
    if (image.id) {
        return await httpClient.put(`/admin/v1/infotv/content/image/${image.id}/`, formData);
    }
    else {
        return await httpClient.post('/admin/v1/infotv/content/image/', formData);
    }
}

export const deleteInfoTvImage = async (imageId) => {
    const response = await httpClient.delete(`/admin/v1/infotv/content/image/${imageId}/`);
    return response;
}

// Footer Texts Management
export const getInfoTvFooterTexts = async (screenId) => {
    const response = await httpClient.get(`/admin/v1/infotv/screens/${screenId}/footer-texts/`);
    return response;
}

export const saveInfoTvFooterText = async (screenId, text) => {
    const response = await httpClient.post(`/admin/v1/infotv/screens/${screenId}/footer-texts/`, { text });
    return response;
}

export const deleteInfoTvFooterText = async (screenId, textId) => {
    const response = await httpClient.delete(`/admin/v1/infotv/screens/${screenId}/footer-texts/${textId}/`);
    return response;
}

export const sortInfoTvFooterTexts = async (screenId, textIds) => {
    const response = await httpClient.post(`/admin/v1/infotv/screens/${screenId}/footer-texts/sort/`, textIds);
    return response;
}

// News Preview
export const getInfoTvNewsPreview = async (screenId) => {
    const response = await httpClient.get(`/admin/v1/infotv/screens/${screenId}/news-preview/`);
    return response;
}
